<!-- Auswahl einer Harmonika-Stimmung (G-C-F-B, A-D-G-C …). Two-way: v-model:tuning (Schlüssel aus INSTRUMENT_TUNINGS). -->
<script setup lang="ts">
import {INSTRUMENT_TUNINGS} from './instrumentData'

const tuning = defineModel<string>('tuning', {required: true})

const {withMinor = false} = defineProps<{
  /** Zeigt zusätzlich die Molltonarten der Reihen – sinnvoll, wenn nach der Liedtonart gewählt wird. */
  withMinor?: boolean
}>()
</script>

<template>
  <select v-model="tuning" class="rounded-md border px-2 py-1 text-sm">
    <option v-for="option in INSTRUMENT_TUNINGS" :key="option.id" :value="option.id">
      {{ withMinor ? `${option.id} ${option.minorLabel}` : option.id }}
    </option>
  </select>
</template>
